import _map from 'lodash/map'

export const collectStates = (states: any) => {
  const mappedStates = _map(states, (item, key) => ({
    label: item,
    value: key,
  }))

  return mappedStates
}
